import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combine class names with clsx, then resolve Tailwind class conflicts with twMerge.
 * Use everywhere you would otherwise inline `className={[a, b].filter(Boolean).join(" ")}`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
